module.exports = __webpack_public_path__ + "static/media/label-checked.102c33f4.svg";